import DiscordIcon from '@/components/icons/logos/discord'
import FacebookIcon from '@/components/icons/logos/facebook'
import FacebookGamingIcon from '@/components/icons/logos/facebook-gaming'
import InstagramIcon from '@/components/icons/logos/instagram'
import TikTokIcon from '@/components/icons/logos/tiktok'
import TwitchIcon from '@/components/icons/logos/twitch'
import TwitterIcon from '@/components/icons/logos/twitter'
import WebIcon from '@/components/icons/logos/web'
import YoutubeIcon from '@/components/icons/logos/youtube'
import PlaystationIcon from '@/components/icons/platforms/playstation'
import XboxIcon from '@/components/icons/platforms/xbox-one'

const serviceIcons = {
  website: WebIcon,
  psn: PlaystationIcon,
  'xbox-live': XboxIcon,
  'discord-server': DiscordIcon,
  twitter: TwitterIcon,
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  'facebook-gaming': FacebookGamingIcon,
  twitch: TwitchIcon,
  tiktok: TikTokIcon,
  youtube: YoutubeIcon,
}

export function ProfileLinkIcon({ service, className = 'h-7 w-7' }) {
  const Icon = serviceIcons[service]

  if (!Icon) return null

  return (
    <Icon
      aria-hidden="true"
      className={`${className} fill-neutral-blue-200 stroke-neutral-blue-200`}
    />
  )
}
